function initModalListeners(modalEl) {
  var lightbox = modalEl.querySelector('.modal__lightbox');
  var lightboxImg = lightbox ? lightbox.querySelector('.modal__lightbox-img') : null;
  if (!lightbox || !lightboxImg) return;

  modalEl.addEventListener('click', function(e) {
    var btn = e.target.closest('.modal__image-btn');
    if (btn) {
      lightboxImg.src = btn.getAttribute('data-lightbox-src');
      lightboxImg.alt = btn.querySelector('img') ? btn.querySelector('img').alt : '';
      lightbox.classList.add('modal__lightbox--open');
      lightbox.setAttribute('aria-hidden', 'false');
      e.stopPropagation();
    }
  });

  lightbox.addEventListener('click', function(e) {
    if (e.target === lightbox) {
      lightbox.classList.remove('modal__lightbox--open');
      lightbox.setAttribute('aria-hidden', 'true');
      lightboxImg.src = '';
    }
  });
}

document.addEventListener('click', function(e) {
  var trigger = e.target.closest('[data-modal-trigger]');
  if (trigger) {
    var modalId = trigger.dataset.modalTrigger;
    var modal = document.getElementById('modal-' + modalId);

    if (!modal) {
      var template = document.getElementById('modal-template-' + modalId);
      if (template) {
        document.body.appendChild(template.content.cloneNode(true));
        modal = document.getElementById('modal-' + modalId);
        initModalListeners(modal); // attach lightbox listeners for this modal
      }
    }

    if (modal) openModal(modal);
  }

  if (e.target.closest('.modal__close') || e.target.closest('.modal__backdrop')) {
    var modalEl = e.target.closest('.modal');
    if (modalEl) closeModal(modalEl);
  }
});

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    document.querySelectorAll('.modal[aria-hidden="false"]').forEach(closeModal);
  }
});

function openModal(modal) {
  modal.setAttribute('aria-hidden', 'false');
  document.body.classList.add('modal-open');
  if (!modal.querySelector('#bundle-accordion-body')) {
    initModalAccordion(modal);
  }
}

function initModalAccordion(modalEl) {
  modalEl.querySelectorAll('.modal__accordion-header[aria-expanded]').forEach(function(header) {
    if (header.dataset.listenerAttached) return;
    header.dataset.listenerAttached = 'true';
    header.addEventListener('click', function() {
      var body = header.nextElementSibling;
      var isExpanded = header.getAttribute('aria-expanded') === 'true';

      modalEl.querySelectorAll('.modal__accordion-header[aria-expanded="true"]').forEach(function(other) {
        if (other === header) return;
        other.setAttribute('aria-expanded', 'false');
        other.nextElementSibling.style.maxHeight = null;
      });

      if (isExpanded) {
        body.style.maxHeight = null;
        header.setAttribute('aria-expanded', 'false');
      } else {
        body.style.maxHeight = body.scrollHeight + 'px';
        header.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

function closeModal(modal) {
  if (!modal) return;
  modal.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('modal-open');
}